import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    return <Navigate to="/admin" />;
  }

  // Optionally decode and verify token (e.g., check expiration)
  return children;
};

export default AdminRoute;
